import {useQuery} from '@tanstack/react-query';
import {GetProvidersListParams} from 'domain/usecases/private/authorizations/get-providers-list';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getProvidersList} from '../services/getProvidersList';

export const useGetProvidersListQuery = (params: GetProvidersListParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.AUTOSOL_REQUEST_PROVIDERS_LIST, params],
		queryFn: async ({signal}) => getProvidersList({...params, signal}),
		enabled: false,
	});
